import { render, staticRenderFns } from "./v-loading.vue?vue&type=template&id=f84c93e4&scoped=true&"
import script from "./v-loading.vue?vue&type=script&lang=js&"
export * from "./v-loading.vue?vue&type=script&lang=js&"
import style0 from "./v-loading.vue?vue&type=style&index=0&id=f84c93e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84c93e4",
  null
  
)

export default component.exports